import { Check, Plus } from "lucide-react";
import {
	Autocomplete,
	Box,
	Button,
	MenuItem,
	Modal,
	OutlinedInput,
	Popper,
	Select,
	TextField,
	Typography,
} from "@mui/material";

import { useNursingFunctionsContext } from "../../components/NursingFunctions/NursingFunctionsProvider";
import { AssignedFunction, Function, useAssignFunctionModal } from "./useAssignFunctionModal";
import Grain from "../../assets/images/grain.png";

export default function AssignFunctionModal({
	open,
	onClose,
}: {
	open: boolean;
	onClose: () => void;
}) {
	const {
		assignedFunctions,
		functions,
		selectedNurse,
		selectedFunction,
		isLoading,
		setSelectedNurse,
		setSelectedFunction,
		canSave,
		onSave,
		onClean,
	} = useAssignFunctionModal();

	const { reloadInformation } = useNursingFunctionsContext();

	return (
		<Modal
			open={open}
			className="modal-container"
		>
			<Box className="modal modal--big">
				<Box
					sx={{
						display: isLoading ? "flex" : "none",
					}}
				>
					<Box className="custom-loader__background"></Box>
					<Box className="custom-loader" />
				</Box>
				<Box className="modal__header">
					<img
						className="modal__header__grain"
						src={Grain}
					/>
					<Plus className="modal__header__icon" />
					<Box>
						<Typography className="modal__header__title">Asignar Función</Typography>
						<Typography className="modal__header__subtitle">
							Asigna una función al personal de enfermería.
						</Typography>
					</Box>
				</Box>
				<Box className="modal__body">
					<Box display={"flex"}>
						<Box
							className="modal__body__field"
							style={{
								flexGrow: "2",
								marginRight: "1rem",
							}}
						>
							<Typography className="modal__body__label">Profesional</Typography>
							<Autocomplete
								className="modal__body__select"
								options={assignedFunctions}
								size="small"
								getOptionLabel={(option: AssignedFunction) => option.nurseName}
								value={
									assignedFunctions.find((item) => item.nurseId === selectedNurse) || null
								}
								onChange={(_, newValue) => {
									setSelectedNurse(newValue ? newValue.nurseId : "");
								}}
								renderInput={(params) => (
									<TextField {...params} placeholder="Seleccionar" />
								)}
								isOptionEqualToValue={(option, value) => option.nurseId === value.nurseId}
							/>
						</Box>
						<Box className="modal__body__field">
							<Typography className="modal__body__label">Categoría</Typography>
							<TextField
								disabled
								className="modal__body__textfield"
								defaultValue={"-"}
								value={
									assignedFunctions.find(
										(assignedFunction: AssignedFunction) =>
											assignedFunction.nurseId === selectedNurse,
									)?.classx
								}
							></TextField>
						</Box>
					</Box>
					<Box className="modal__body__field">
						<Typography className="modal__body__label">Función</Typography>
						<Autocomplete
							className="modal__body__select"
							options={functions}
							size="small"
							getOptionLabel={(option: Function) => option.description}
							value={functions.find((f) => f.id === selectedFunction) || null}
							onChange={(_, newValue) => {
								setSelectedFunction(newValue ? newValue.id : "");
							}}
							renderInput={(params) => (
								<TextField {...params} placeholder="Seleccionar" />
							)}
							isOptionEqualToValue={(option, value) => option.id === value.id}
							PopperComponent={(props: any) =>
								<Popper {...props} sx={{overflow: 'hidden', maxHeight: '350px', borderRadius: '8px'}} placement="bottom-start" />
							}
						/>
					</Box>
				</Box>
				<Box
					className="modal__buttons"
					justifyContent={"flex-end"}
				>
					<Button
						className="modal__buttons--close"
						onClick={() => {
							onClose();
							onClean();
						}}
					>
						Cerrar
					</Button>
					<Button
						className="modal__buttons--save"
						startIcon={<Check />}
						disabled={!canSave()}
						onClick={async () => {
							await onSave();
							onClose();
							reloadInformation();
						}}
					>
						Guardar
					</Button>
				</Box>
			</Box>
		</Modal>
	);
}
